import React from 'react';
import Fade from 'react-reveal/Fade';
import Typical from 'react-typical'
import isti from '../../images/istiaque.png'
import './Banner.css'
const Banner = () => {
    return (
        <div className='banner-img mb-5'>

            <Fade left>
                <div className='text-part row'>
                    <div className="col-lg-8 col-md-12 col-sm-12">
                        <h4 className='head-name'>Hi!I'm Isti</h4>
                        <Typical
                            className='text-light fs-1 mt-3 fw-bold'
                            steps={['Web Developer', 1000, 'Frontend Developer', 1000, 'Mern Stack Developer', 1000]}
                            loop={Infinity}
                            wrapper="w"
                        />

                        <h2 className='based-part text-danger fs-1'>Based In Bangladesh.</h2>
                        <p className='desc'>I am a Frontend developer. I love programming. I love to explore and learn. I am passionate about building excellent software that improves the lives of those around me.</p>
                        <button className='button-banner'> <a className='text-decoration-none text-dark fw-bold' href="https://docs.google.com/document/d/14AwHapZYrLHDIBu2w1dr3JjmIP1mErO-C0gszxQ4O3w/edit?usp=sharing" target="_blank">Download Resume</a></button>


                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12">
                        <img className='w-100 img-fluid' src={isti} alt="" />
                    </div>
                </div>
            </Fade>



        </div>
    );
};

export default Banner;